<template>
  <Transition
    enter-active-class="transition duration-200 ease-out"
    enter-from-class="opacity-0 -translate-y-1"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition duration-150 ease-in"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 -translate-y-1"
  >
    <section v-if="open" class="filter-panel">
      <div class="filter-panel__header">
        <div>
          <h2 class="filter-panel__title">{{ title }}</h2>
          <p v-if="subtitle" class="filter-panel__subtitle">{{ subtitle }}</p>
        </div>
        <button type="button" class="filter-panel__close" aria-label="Hide filters" @click="close">
          <XMarkIcon class="h-5 w-5" aria-hidden="true" />
        </button>
      </div>

      <div class="filter-panel__body">
        <slot />
      </div>

      <div v-if="$slots.footer" class="filter-panel__footer">
        <slot name="footer" />
      </div>
    </section>
  </Transition>
</template>

<script>
import { Transition } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'FilterDrawer',
  components: {
    Transition,
    XMarkIcon,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Filters',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
